// extracted by mini-css-extract-plugin
export default {"background":"hG","weightImage":"iG","drinkImage":"jG","content":"kG","rtbLeft":"lG","rtbRight":"mG","rtbLeftMobile":"nG","imageContainer":"oG","rtbBox":"pG","line":"qG","rtbDesktop":"rG"};
    if(module.hot) {
      // 1713211520811
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  